import { FormProps } from 'types/form';
import { ProductCategory } from '../types/dtos';
import { ReactNode } from 'react';
import OWForm from 'components/layout/ow-form';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OWSelect from 'components/design/ow-select';
import FormFooter from 'components/layout/form-footer';
import { LoadingButton } from '@mui/lab';
import { useFilterSelectOptions } from '../constants/status';
import { isEmpty } from 'utils/object-helpers';

export type ProductCategoryFormProps = FormProps<ProductCategory>;

type ProductCategotyFormType = (props: ProductCategoryFormProps) => ReactNode;

export const ProductCategoryForm: ProductCategotyFormType = ({
    formData: productCategory,
    onChange,
    onSubmit,
    onCancel,
    isSaveLoading,
    errors,
    disableSubmit,
}) => {
    const { t } = useTranslation();
    const FILTER_SELECT_OPTIONS = useFilterSelectOptions();

    return (
        <OWForm onSubmit={onSubmit}>
            <Typography variant="h6">{t('PRODUCT_CATEGORY_FORM.HEADER')}</Typography>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <Stack width="100%" spacing={1.5}>
                    <TextField
                        value={productCategory.name}
                        onChange={(e) => onChange('name', e.target.value)}
                        placeholder={t('PRODUCT_CATEGORY_FORM.PLACEHOLDER_NAME')}
                        label={t('PRODUCT_CATEGORY_FORM.LABEL_NAME')}
                        required
                        autoFocus
                        error={!!errors?.name}
                        helperText={errors?.name?.errorMessage}
                    />
                    <OWSelect
                        value={productCategory.isActive.toString()}
                        items={FILTER_SELECT_OPTIONS}
                        label={t('PRODUCT_CATEGORY_FORM.LABEL_STATUS')}
                        labelId="label-status"
                        error={!!errors?.isActive}
                        onChange={(e) => onChange('isActive', e.target.value)}
                    />
                </Stack>
            </Stack>

            <FormFooter>
                <Stack direction="row" width="360px" spacing={3}>
                    <Button variant="outlined" onClick={onCancel}>
                        {t('PRODUCT_CATEGORY_FORM.CANCEL_BUTTON')}
                    </Button>
                    <LoadingButton loading={isSaveLoading} type="submit" disabled={!isEmpty(errors) || disableSubmit}>
                        {t('PRODUCT_CATEGORY_FORM.SAVE_BUTTON')}
                    </LoadingButton>
                </Stack>
            </FormFooter>
        </OWForm>
    );
};
